// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const storedPermissions = sessionStorage.getItem("permissions");
    if (storedPermissions) {
      try {
        const parsed = JSON.parse(storedPermissions);
        setPermissions(parsed);
      } catch (error) {
        console.error("Error parsing permissions:", error);
      }
    }
  }, []);

  const hasPermission = (permission) => permissions.includes(permission);

  return (
    <AuthContext.Provider value={{ permissions, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);